import styled from 'styled-components';
import { Container, Inner } from 'styles/global.styled';
import { mediumBreakpoint } from 'utilities/constants';

export const BackgroundContainer = styled.div`
  position: fixed;
  background-image: url(logo_transparent.png);
  background-color: #00000008;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  height: 100vh;
  width: 100vw;
  top: 0;
  z-index: -1;
`;

export const AIContainer = styled(Container)`
  /* background: #f7fafc4f; */
  padding: 5rem 0 3rem;
  border: none;

  p {
    color: #959595;
    font-family: 'Inter', sans-serif;
    font-size: 1em;
    line-height: 1.875;
    font-weight: 300;
  }

  @media (max-width: ${mediumBreakpoint}px) {
    padding: 1rem 0 3rem;
    background: linear-gradient(to top, #ffffffbf 60%, #3c65810d 90%);
  }

  @media (min-width: ${mediumBreakpoint}px) {
    background: linear-gradient(to right, #ffffffbf 60%, #3c65810d 90%);

    :nth-child(odd) {
      background: linear-gradient(to left, #ffffffbf 60%, #3c65810d 90%);
    }
  }
`;

export const AIInner = styled(Inner)`
  flex-wrap: wrap;
  display: flex;
  align-items: center;
  text-align: left;
  padding: 0rem 3rem;

  @media (max-width: ${mediumBreakpoint}px) {
    padding: 0rem 1.5rem;
  }
`;
